import { render, staticRenderFns } from "./StandardHeader.vue?vue&type=template&id=b96750f4&scoped=true"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"
import style0 from "./StandardHeader.vue?vue&type=style&index=0&id=b96750f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96750f4",
  null
  
)

export default component.exports